import React from "react";
import { TLParentId } from "@tldraw/tldraw";
import Tooltip from "@material-ui/core/Tooltip";
import cn from "classnames";
import useTooltipStyles from "./style";
import { getClosestContainer, hideSelectionTemporarily } from "../../utils";
import FlipHorizontalIcon from "components/icons/components/FlipHorizontalIcon";
import FlipVerticalIcon from "components/icons/components/FlipVerticalIcon";

interface FlipComponentProps {
  selectedShape: any;
  setSelectedShape: (shape: any) => void;
  editor: any;
  isVerticalFlip?: boolean;
  selectedShapeIds: any[];
}

const FlipComponent = ({
  selectedShape,
  setSelectedShape,
  editor,
  isVerticalFlip,
  selectedShapeIds,
}: FlipComponentProps) => {
  const classes = useTooltipStyles();

  const handleFlip = () => {
    try {
      // Validate that we have a selected shape
      if (!selectedShape) {
        console.warn("No shape selected for flipping");
        return;
      }

      const frontSaveZoneId = "shape:frontBorderDashLine" as TLParentId;
      const backSaveZoneId = "shape:backBorderDashLine" as TLParentId;
      const closestContainer = getClosestContainer(frontSaveZoneId, backSaveZoneId, editor, selectedShape);

      if (!closestContainer) {
        console.warn("No container found for the selected shape");
        return;
      }

      const operation = isVerticalFlip ? "vertical" : "horizontal";

      // Handle different shape types appropriately
      if (selectedShape?.type === "customText") {
        // For text shapes, update the flip properties directly
        const updatedShape = {
          ...selectedShape,
          props: {
            ...selectedShape.props,
            flipH: operation === "horizontal" ? !selectedShape.props.flipH : selectedShape.props.flipH,
            flipV: operation === "vertical" ? !selectedShape.props.flipV : selectedShape.props.flipV,
          },
        };

        editor.updateShape(updatedShape);
        setSelectedShape(updatedShape);
        hideSelectionTemporarily(updatedShape, editor);
      } else {
        // For other shapes (including images), use the flipShapes command
        try {
          editor.flipShapes([selectedShape.id], operation);

          // Update the selected shape state
          const updatedShape = { ...selectedShape, flip: operation };
          setSelectedShape(updatedShape);
          hideSelectionTemporarily(selectedShape, editor);
        } catch (error) {
          console.error("Error flipping shape:", error);
          // Fallback: try to update the shape directly with flip properties
          const updatedShape = {
            ...selectedShape,
            props: {
              ...selectedShape.props,
              flipX: operation === "horizontal" ? !selectedShape.props.flipX : selectedShape.props.flipX,
              flipY: operation === "vertical" ? !selectedShape.props.flipY : selectedShape.props.flipY,
            },
          };

          editor.updateShape(updatedShape);
          setSelectedShape(updatedShape);
          hideSelectionTemporarily(updatedShape, editor);
        }
      }
    } catch (error) {
      console.error("Error in handleFlip:", error);
      // Don't crash the application, just log the error
    }
  };

  return null;
};

export default FlipComponent;
